import { render } from "./photographerLandingPage.vue?vue&type=template&id=49cd0463&scoped=true"
import script from "./photographerLandingPage.vue?vue&type=script&lang=js"
export * from "./photographerLandingPage.vue?vue&type=script&lang=js"

import "./photographerLandingPage.vue?vue&type=style&index=0&id=49cd0463&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cd0463"]])

export default __exports__